import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  FETCH_ACCESS_LOG,
  FETCH_ACTIVITY_LOG,
  M_GET,
  M_POST,
} from '@/utils/api';

import { IFetchActivity } from '@/interface/Activity';

import Vue from 'vue';

@Module({ name: 'activity' })
export default class Activity extends VuexModule {
  @Action
  FetchActivityLog(params: IFetchActivity) {
    return Vue.axios({
      url: BASE_URL + FETCH_ACTIVITY_LOG,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data;
        } else {
          throw data;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchActivityLogAgent() {
    return Vue.axios({
      url: BASE_URL + FETCH_ACCESS_LOG,
      method: M_GET,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data;
        } else {
          throw data;
        }
      })
      .catch((err) => err);
  }
}
